import React, {Component} from 'react';
import {ApiClient} from "../../libs/apiClient/ApiClient";
import {CommentsModal, NavBar, Session} from "../../components";
import {DISPATCH_ID, SERVICE_API, SERVICE_RESPONSE, VIEW_NAME, config} from "../../libs/utils/Const";
import moment from "moment";
import {connect} from "react-redux";
import {CSVLink, CSVDownload} from "react-csv";
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';
import ExportReportPDF from '../../components/ExportReportPDF';

let apiClient = ApiClient.getInstance();

class DocumentsCreatedCMView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            DocumentosCreados : [],
            csvData: [],
            order: [],
        };
        this.table = null;
    }

    async componentDidMount(): void {
        //const {enableSpinner} = this.props;
        //enableSpinner(true);
        let fechaInicio = moment(new Date()).format('YYYY-MM-DD');
        let fechaFinal = moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            fechaInicio,
            fechaFinal,
            fechaActual : moment(new Date()).format('YYYY-MM-DD')
        });
        setTimeout(async() => {
            this.cargarDatos();
        }, 400);
        //enableSpinner(false);
    }

    async cargarDatos (){
        const {enableSpinner} = this.props;
        enableSpinner(true);
        const {fechaInicio, fechaFinal} = this.state;
        let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
        user = JSON.parse(user) || {};
        let data ={
            fechaInicio : fechaInicio,
            fechaFinal : fechaFinal,
        }
        let creados = await apiClient.getCreateCanalModerno(data);
        this.setState({
            usuario : user,
            DocumentosCreados : creados.data.list
        });
        this.table = $('#documents').DataTable({
            "paging": false,
            "info": false,
            "searching": false
        });
        enableSpinner(false);
    };
    
    DetailsOQUT = async (valor,tipo) => {
        const {usuario} = this.state;
        const {enableSpinner} = this.props;
        enableSpinner(true);
        let data = {
            valor : valor,
            tipo : tipo
        }
        let response = await apiClient.getDatailsAutoCanalModerno(data);
        let csvData = [];

        if(response.status === 1){
            // showAlert({type: 'success', message: ' Agregado a carrito correctamente ', timeOut: 0});
            let infoCsv = response.data.body;
            infoCsv.map((item)=>{
                let precioFinal = item.U_SYP_CCCOMENT - (item.U_SYP_CCCOMENT * (item.U_SYP_NOMEMP / 100));
                let totalsinIgv = (precioFinal)*(item.Quantity);
                let row ={
                    'Producto': item.ItemName,
                    'EAN': item.ItemCode,
                    'Cantidad': item.Quantity,
                    'Precio': item.Currency+' '+ parseFloat(item.Price).toFixed(2),
                    'Descuentos': parseFloat(item.DiscPrcnt).toFixed(2) + ' %',
                    'Precio Total': item.Currency+' '+parseFloat(item.LineTotal).toFixed(2),
                    'Info': ' '
                }
                csvData.push(row);
            });
            
            for (let index = 0; index < 2; index++) {
                const element = csvData[index];
                let row ={
                    'Info': ' '
                }
                csvData.push(row);
            }
            let hoy = new Date();
            var Hora = hoy.getHours();
            var Min = hoy.getMinutes();
            var Fecha = hoy.toLocaleDateString();
                
            csvData[0].Info = "RUC "+response.data.body[0].CardCode.substring(1)+"        "+Fecha+"-"+Hora+":"+Min+"hs        ";// +usuario.CardName
            csvData[1].Info = "NRO.SOLICITUD: "+response.data.body[0].DocEntry;
            csvData[2].Info = "CLIENTE: "+response.data.body[0].CardName+"        EMISIÓN: "+response.data.body[0].DocDate.substring(0,10)+" - F.DESPACHO : "+response.data.body[0].DocDueDate.substring(0,10)+" - O/C : "+response.data.body[0].NumAtCard;

            response = response ? response.data.body : []
                this.setState({
                    order: response,
                    DocEntry : valor,
                    csvData,
                    action : 1,
                    cliente : response[0].CardCode,
                    nombre : response[0].CardName,
                    documento : response[0].DocNum,
                });
            $('#saveModal').modal('show');
        }

        enableSpinner(false);
        
    };

    handleInputDateInicio = event =>{
        let fechaInicio = event.nativeEvent.target.value;
        this.setState({
            fechaInicio
        });
    }

    handleInputDateFinal = event =>{
        let fechaFinal = event.nativeEvent.target.value;
        this.setState({
            fechaFinal
        });
    }

    getData = async () =>{        
        this.table.destroy();
        this.cargarDatos();
    }
    
    render() {
        const {history} = this.props;
        const {order,csvData, DocumentosCreados,action, cliente, nombre, documento, fechaInicio, fechaFinal, fechaActual} = this.state;
        return (
            <div className="content-fluid" style={{marginTop: 66}}>
                <Session history={history} view={VIEW_NAME.CANALMODERNO_VIEW}/>
                <NavBar/>
                <div className="container mb-4" style={{paddingTop: 60}}>
                    <div className="row">
                        <div className="col">
                            <div className="jumbotron" style={{paddingTop:'10px', paddingBottom:'10px'}}>
                                <h1 className="display-6 text-center">Documentos creados Canal Moderno</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                        <div className=" row col-md-4">
                            <h4 className="pr-2">Desde:</h4>
                            <input 
                                id="fechaInicio"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechauno" 
                                max={fechaActual}
                                value = {fechaInicio}
                                onChange = {(event) => this.handleInputDateInicio(event)}/>
                        </div>
                        <div className="row col-md-4 pb-3">
                            <h4 className="pr-2">Hasta:</h4>
                            <input 
                                id="FechaFin"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechados" 
                                max={fechaActual}
                                value = {fechaFinal}
                                onChange = {(event) => this.handleInputDateFinal(event)}/>
                        </div>
                        <div className="col-md-2 pb-2">
                            <button
                                onClick={()=>this.getData()}
                                className="btn botonResumen" 
                                style={{
                                    backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                    color: config.navBar.textColorCategorieHover,
                                    fontWeight: "bold",
                                }}>
                                Listar
                            </button>
                        </div>
                    </div>  

                {/* <div className="container col-md-8 col-sm-12" > */}
                <div className="col-md-11 col-sm-12" style={{marginRight:'auto', marginLeft:'auto'}}>
                    <div className="table-responsive" style={{marginBottom: 0, height: 450, maxHeight: 450, overflow: 'auto'}}>  {/* width: 1500, maxWidth: 1500, fontSize:"13px", fontWeight:"bold" */}
                        <table id="documents" className="table table-hover scrolltable" style={{marginRight: 0, marginLeft: 0}}> 
                            <thead >
                                <tr className="text-light" style={{/*background: '#2d75bd', borderRadius: '0' */}} >
                                    {/* <th >#</th> */}
                                    {/* <th className="sticky-header"  scope="col">DocNum</th> */}
                                    <th scope="col">Cód. cliente</th>
                                    <th scope="col">Cliente</th>
                                    <th scope="col">Documento</th>
                                    <th scope="col">F. Emisión</th>
                                    <th scope="col">F. Despacho</th>
                                    <th scope="col">Orden de compra</th>
                                    <th scope="col">No. Pedido</th>
                                    <th scope="col">No. de Factura</th>
                                    <th scope="col">Referencial</th>
                                    <th scope="col">Peso Neto</th>
                                    <th scope="col">Monto</th>
                                    <th scope="col">Oferta de ventas</th>
                                    <th scope="col">Orden de venta</th>
                                    <th scope="col">Notificación</th>
                                </tr>
                            </thead>
                            <tbody>{/* style={{overflowY:'auto'}} */}
                            
                                {!!DocumentosCreados && DocumentosCreados.map((create, index ) => {
                                        return(
                                            <tr >
                                                {/* <th >{index+1}</th> */}
                                                <td>{create.CardCode}</td>
                                                <td>{create.CardName}</td>
                                                <td>{create.doc}</td>
                                                <td>{create.DocDateORDR == null ? '--' : moment(create.DocDateORDR).format('DD-MM-YYYY')}</td>
                                                <td>{create.DocDueDateORDR == null ? '--' : moment(create.DocDueDateORDR).format('DD-MM-YYYY')}</td>
                                                <td>{create.NumAtCardORDR}</td>
                                                <td>{create.DocNumORDR}</td>
                                                <td>{create.DocEntryOINV}</td>
                                                <td>{create.NumAtCard}</td>
                                                <td>{parseFloat(create.Neto || 0).toFixed(2)+ ' KG'}</td>
                                                <td>
                                                    <CurrencyFormat
                                                        value={create.DocTotalORDR || 0}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2}
                                                        prefix={config.general.currency}>
                                                    </CurrencyFormat>
                                                </td>
                                                {/* <td className="text-center">{create.docEntryOQUT}</td> */}
                                                <td style={{padding: 0}}>
                                                    <button
                                                        className="btn btn-sm"
                                                        type="button"
                                                        style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                        onClick={() => this.DetailsOQUT(create.docEntryOQUT, 'OQUT')}>
                                                    Ver Oferta
                                                    </button>
                                                </td>
                                                {/* <td className="text-center">{create.docEntryORDR}</td> */}
                                                <td style={{padding: 0}}>
                                                    <button
                                                        className="btn btn-sm btn-success"
                                                        disabled={create.borrador ===1 || create.borrador === null ? true : false }
                                                        type="button"
                                                        // data-toggle="modal" data-target=".bd-example-modal-lg"
                                                        // style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                        onClick={() => this.DetailsOQUT(create.docEntryORDR, 'ORDR')}>
                                                    Ver Orden
                                                    </button>
                                                </td>
                                                <td style={{padding: 0}}>{create.autorizacion}</td>
                                            </tr>
                                        )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="modal fade bd-example-modal-xl" id="saveModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header text-light" style={{background: '#2d75bd', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Detalle del documento</h4>

                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <br></br>


                        <div className="container col-md-11">
                            <div class="form-row">
                                <div class="col-md-4 mb-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="cliente">Cliente</span>
                                        </div>
                                        <input type="text" class="form-control" value={cliente} aria-describedby="cliente" disabled="true"/>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="name">Nombre</span>
                                        </div>
                                        <input type="text" class="form-control" value={nombre} aria-describedby="name" disabled="true"/>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="documento">Documento</span>
                                        </div>
                                        <input type="text" class="form-control" value={documento} aria-describedby="documento" disabled="true"/>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive" style={{marginBottom: 0, height: 600, maxHeight: 600 , overflow: 'auto', fontSize:"13px", fontWeight:"bold"}}>
                                <table className="table table-hover scrolltable" >
                                    <thead >
                                        <tr className="text-light" style={{/*background: '#2d75bd', borderRadius: '0' */}} >
                                            <th>#</th>
                                            {/* <th className="sticky-header"  scope="col">DocNum</th> */}
                                            <th className="text-center" >Artículo</th>
                                            <th className="text-center" scope="col">Código</th>
                                            <th className="text-center" scope="col">Cantidad</th>
                                            <th className="text-center" scope="col">Precio</th>
                                            <th className="text-center" scope="col">Total</th>
                                            <th className="text-center" scope="col">Total CEN</th>
                                            {/* <th className="text-center" scope="col">Total doc.</th>
                                            <th className="text-center" scope="col">Peso total bruto</th>
                                            <th className="text-center" scope="col">Autorización</th> */}
                                        </tr>
                                    </thead>
                                    <tbody style={{overflowY:'auto'}}>
                                        {!!order && order.map((item, index ) => {
                                                return(
                                                    <tr >
                                                        <th >{index+1}</th>
                                                        {/* <td>{auto.DocNum}</td> */}
                                                        <td className="text-left">{item.ItemName}</td>
                                                        <td className="text-center">{item.ItemCode}</td>
                                                        <td className="text-center">{parseInt(item.Quantity)}</td>
                                                        <td className="text-center">{item.Currency+' '+parseFloat(item.Price).toFixed(2)}</td>
                                                        <td className="text-center">{item.Currency+' '+parseFloat(item.LineTotal).toFixed(2)}</td>
                                                        <td className="text-center">{item.Currency+' '+parseFloat(item.U_RNT_CEN_TOTALIN || 0).toFixed(4)}</td>
                                                        {/* <td className="text-center">S/. {parseFloat(auto.DocTotal).toFixed(2) === '0.00' ? parseFloat(auto.DocTotal2).toFixed(2) : parseFloat(auto.DocTotal).toFixed(2)}</td>
                                                        <td className="text-center">{parseFloat(auto.Weight2).toFixed(2)} KG</td>
                                                        <td className="text-center">{auto.U_Remarks}</td> */}
                                                    </tr>
                                                )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                            <div className="modal-footer justify-content-right">

                            <CSVLink
                                className="btn btn-success float-right"
                                style={{display:action === 1 ? 'block' : 'none' }}
                                data={csvData} filename={"CanalModerno.csv"}>
                                    Descargar Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                            </CSVLink>
                            <ExportReportPDF data={order}></ExportReportPDF>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentsCreatedCMView);